import ErrorStatus from '$shared/constants/ErrorStatus';
import Label from '$shared/constants/Label';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { formatString } from '$shared/helpers/utils';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';

class AuditError {
  public getList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        formatString(UIErrorMessage.FailedToGetList, Label.EventLog),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        formatString(UIErrorMessage.PermissionMissingToGetList, Label.EventLog),
        true
      )
    };
  }

  public getExportList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        formatString(UIErrorMessage.FailedToGetList, Label.DownloadLog),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        formatString(UIErrorMessage.PermissionMissingToGetList, Label.DownloadLog),
        true
      )
    };
  }
}

export const auditError = new AuditError();
